export default {
  StateProvinceRegionFormField__ARIA: "State, Province, or Region",
  StateProvinceRegionFormField__LABEL: "State/Province/Region",
};
